import { Client, type Room } from 'colyseus.js';
import { HTTP_BASE, WS_URL } from '../env.js';
import type { GameState } from './state.js';

export class Connection {
  private client = new Client(WS_URL);
  room: Room<GameState> | null = null;

  async createRoom(name: string): Promise<Room<GameState>> {
    this.room = await this.client.create<GameState>('gladiators', { name });
    return this.room;
  }

  async joinRoom(code: string, name: string): Promise<Room<GameState>> {
    const res = await fetch(`${HTTP_BASE}/api/rooms/${encodeURIComponent(code.toUpperCase())}`);
    if (!res.ok) {
      const body = (await res.json().catch(() => ({}))) as { error?: string };
      throw new Error(body.error ?? `Could not join room (${res.status}).`);
    }
    const { roomId } = (await res.json()) as { roomId: string };
    this.room = await this.client.joinById<GameState>(roomId, { name });
    return this.room;
  }

  async leave(): Promise<void> {
    if (this.room) {
      try {
        await this.room.leave(true);
      } catch {
        /* ignore */
      }
      this.room = null;
    }
  }
}
